import React from 'react';
import withDefaultProps from 'helpers/withDefaultProps';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Row, Col } from 'react-bootstrap';
import { ButtonWithArrows } from 'components';
import * as Ui from './CardContainer.styles';

const CardContainer = ({ children, showBackButton, backButtonTarget, standard, ...restProps }) => {
  const navigate = useNavigate();
  const { t } = useTranslation(['pages']);

  return (
    <Ui.StyledContainer>
      <Row
        className="justify-content-center"
        style={!standard ? { display: 'flex', alignItems: 'center' } : null}
      >
        <Col {...restProps}>
          <Ui.StyledCard>
            {children}
            {(showBackButton || backButtonTarget) && (
              <ButtonWithArrows
                className="mt-3"
                block
                size="lg"
                variant="outline-primary"
                type="submit"
                onClick={() => (backButtonTarget ? navigate(backButtonTarget) : navigate(-1))}
                back
              >
                {t('onboarding.goBack')}
              </ButtonWithArrows>
            )}
          </Ui.StyledCard>
        </Col>
      </Row>
    </Ui.StyledContainer>
  );
};

CardContainer.propTypes = { ...withDefaultProps() };

export default CardContainer;
